import { Layout, Image } from 'antd';
import React from 'react';
import { DrawerElem, LogoContainer } from './styles';

import logoKothe from '../../../assets/img/logo-kothe.png';
import logoKotheK from '../../../assets/img/logo-kothe-xs.png';
import logoKotheDark from '../../../assets/img/kothe-logo-dark.png';
import logoKotheKDark from '../../../assets/img/logo-kothe-xs-dark.png';
import Links from './Links';
import { THEME_MODE } from 'utils/enums/theme.enum';

interface SiderMenuProps {
  collapsed: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  theme: string;
}

const SiderMenu: React.FC<SiderMenuProps> = ({ collapsed, setCollapsed, theme }) => {
  const imgLogo =
    collapsed && theme === THEME_MODE.light
      ? logoKotheK
      : collapsed && theme === THEME_MODE.dark
      ? logoKotheKDark
      : !collapsed && theme === THEME_MODE.light
      ? logoKothe
      : logoKotheDark;

  const { Sider } = Layout;

  return (
    <>
      <Sider
        className="sider"
        breakpoint="md"
        trigger={null}
        collapsible
        collapsed={collapsed}
        width="260px"
        onBreakpoint={(broken) => {
          setCollapsed(broken);
        }}
      >
        <LogoContainer>
          <Image preview={false} alt="Kothe" src={imgLogo} />
        </LogoContainer>

        <Links collapsed />
      </Sider>

      <DrawerElem
        placement="left"
        closable={false}
        onClose={() => setCollapsed(!collapsed)}
        visible={!collapsed}
        bodyStyle={{ padding: 0 }}
        className="drawer-menu"
      >
        <LogoContainer>
          <Image
            preview={false}
            alt="Kothe"
            src={!collapsed && theme === THEME_MODE.light ? logoKothe : logoKotheDark}
          />
        </LogoContainer>

        <Links collapsed />
      </DrawerElem>
    </>
  );
};

export default SiderMenu;
